// extracted by mini-css-extract-plugin
module.exports = {"LoadError":"bet_a bhe_pw bhe_a bhe_w bhe_j bhe_q","LoadError__icon":"bet_b bhe_uf bhe_fg bhe_rq","LoadError__message":"bet_c bhe_fg bhe_sl"};